import script from "./ui-checkbox.vue?vue&type=script&lang=ts&setup=true"
export * from "./ui-checkbox.vue?vue&type=script&lang=ts&setup=true"

import "./ui-checkbox.vue?vue&type=style&index=0&id=0555ce38&lang=less"

const __exports__ = script;

export default __exports__